import { createAction } from 'redux-act';
// report-common
import { getReportActions } from '../../report-common';
//////////////////////////////////////////////////

const {
  setReports,
  selectItem,
  setUsedReport,
  setListLoading,
  setFilterProps,
  setInitialState,
  setReportPending,
  cleanQuickFilter,
  setTableTitleSort,
  getItemListRequest,
  getItemListSuccess,
  createReportRequest,
  updateReportRequest,
  setTableTitleFilter,
  setQuickFilterParams,
  setIgnorePromptStatus,
  resetListAndPagination,
  exportReportDataRequest,
  changeDefaultReportRequest,
  getAvailableReportsRequest,
} = getReportActions();

const setEditPage = createAction('setEditPage');
const openEditReportModal = createAction('openEditReportModal');
const deleteReportRequest = createAction('deleteReportRequest');
const setUsedReportStatus = createAction('setUsedReportStatus');
const getReportDataRequest = createAction('getReportDataRequest');
const cleanReportStateAction = createAction('cleanReportStateAction');
const updateReportOwnerRequest = createAction('updateReportOwnerRequest');
const receivedUsedReportSuccess = createAction('receivedUsedReportSuccess');
const receivedDeleteReportSuccess = createAction('receivedDeleteReportSuccess');

export {
  setReports,
  selectItem,
  setEditPage,
  setUsedReport,
  setFilterProps,
  setListLoading,
  setInitialState,
  setReportPending,
  cleanQuickFilter,
  setTableTitleSort,
  getItemListRequest,
  getItemListSuccess,
  openEditReportModal,
  deleteReportRequest,
  createReportRequest,
  updateReportRequest,
  setUsedReportStatus,
  setTableTitleFilter,
  setQuickFilterParams,
  getReportDataRequest,
  setIgnorePromptStatus,
  cleanReportStateAction,
  resetListAndPagination,
  exportReportDataRequest,
  updateReportOwnerRequest,
  receivedUsedReportSuccess,
  changeDefaultReportRequest,
  getAvailableReportsRequest,
  receivedDeleteReportSuccess,
};
